import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';

import styles from './index.css';


const tierMapping = {
  '0': styles.white,
  '1': styles.blue,
  '2': styles.purple,
  '3': styles.yellow,
  '4': styles.orange,
};

const TierIcon = (props) => {
  const { text, type } = props;

  const imageClasses = classNames(styles.icon, tierMapping[type]);

  const tierElement = useMemo(() => {
    if (type === '0') {
      return null;
    }

    return (
      <span className={styles.capitalize}>
        {translate('v2broadcast.tier')}
      </span>
    );
  }, [type]);

  return (
    <div className={styles.item}>
      <div className={imageClasses} />
      <span>{tierElement} {text}</span>
    </div>
  );
};

TierIcon.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default memo(TierIcon);
